import { pieChartTransform } from "../adpaters/transformers/pie-chart.transform"
import { PieChartService } from "../services/pie-chart.service"

export enum PieChartType {
    JURISDICTION_MARKET_CAPS = "jurisdiction-market-caps",
    DOMICILIATION_MARKET_CAPS = "domiciliation-market-caps",
    STABLECOINS_SUPPLY_BY_SECTOR = "stablecoins-supply-by-sector",
    STABLECOIN_MARKET_VALUE_PER_PEGGED_ASSET = "stablecoin-market-value-per-pegged-asset",
    BTC_HASHRATE_BY_COUNTRY = "btc_hashrate_by_country",
    BTC_MINING_ENERGY_SOURCE = "btc_mining_energy_source",
}

export interface PieChartConfig {
    id: string
    dataLoader: () => Promise<any>
    transformer: (data: any) => any
    options?: {
        colors?: string[]
        innerRadius?: number
        outerRadius?: number
        labelThreshold?: number
        showPercentage?: boolean
        showAbsoluteValue?: boolean
        sortByValue?: boolean
    }
}

// export const pieChartConfigs = new Map<string, PieChartConfig>([
export const createPieChartConfigs = (pieChartService: PieChartService) => {
    return new Map<string, PieChartConfig>([
        [PieChartType.JURISDICTION_MARKET_CAPS, {
            id: PieChartType.JURISDICTION_MARKET_CAPS,
            dataLoader: () => pieChartService.loadStablecoinsLatest(),
            transformer: pieChartTransform.jurisdictionMarketCapsToPieDO,
            options: {
                // Colors will be selected dynamically based on data series count
                innerRadius: 0,
                outerRadius: 1,
                labelThreshold: 3,
                showPercentage: true,
                showAbsoluteValue: true,
                sortByValue: true
            }
        }],
        [PieChartType.DOMICILIATION_MARKET_CAPS, {
            id: PieChartType.DOMICILIATION_MARKET_CAPS,
            dataLoader: () => pieChartService.loadStablecoinsLatest(),
            transformer: pieChartTransform.domiciliationMarketCapsToPieDO,
            options: {
                // Colors will be selected dynamically based on data series count
                innerRadius: 0,
                outerRadius: 1,
                labelThreshold: 5,
                showPercentage: true,
                showAbsoluteValue: true,
                sortByValue: true
            }
        }],
        [PieChartType.STABLECOINS_SUPPLY_BY_SECTOR, {
            id: PieChartType.STABLECOINS_SUPPLY_BY_SECTOR,
            dataLoader: () => pieChartService.loadStablecoinsLatest(),
            transformer: pieChartTransform.stablecoinsSupplyBySectorToPieDO,
            options: {
                // Colors will be selected dynamically based on data series count
                innerRadius: 0.3, // Donut chart
                outerRadius: 1,
                labelThreshold: 4,
                showPercentage: true,
                showAbsoluteValue: false,
                sortByValue: true
            }
        }],
        [PieChartType.STABLECOIN_MARKET_VALUE_PER_PEGGED_ASSET, {
            id: PieChartType.STABLECOIN_MARKET_VALUE_PER_PEGGED_ASSET,
            dataLoader: () => pieChartService.loadStablecoinsLatest(),
            transformer: pieChartTransform.stablecoinMarketValuePerPeggedAssetToPieDO,
            options: {
                // Colors will be selected dynamically based on data series count
                innerRadius: 0,
                outerRadius: 1,
                labelThreshold: 4,
                showPercentage: true,
                showAbsoluteValue: false,
                sortByValue: true
            }
        }],
        [PieChartType.BTC_HASHRATE_BY_COUNTRY, {
            id: PieChartType.BTC_HASHRATE_BY_COUNTRY,
            dataLoader: () => pieChartService.loadV2(PieChartType.BTC_HASHRATE_BY_COUNTRY),
            transformer: pieChartTransform.defaultPieChartTransform,
            options: {
                // Colors will be selected dynamically based on data series count
                innerRadius: 0,
                outerRadius: 1,
                labelThreshold: 3,
                showPercentage: true,
                showAbsoluteValue: false,
                sortByValue: true
            }
        }],
        [PieChartType.BTC_MINING_ENERGY_SOURCE, {
            id: PieChartType.BTC_MINING_ENERGY_SOURCE,
            dataLoader: () => pieChartService.loadV2(PieChartType.BTC_MINING_ENERGY_SOURCE),
            transformer: pieChartTransform.defaultPieChartTransform,
            options: {
                // Colors will be selected dynamically based on data series count
                innerRadius: 0,
                outerRadius: 1,
                labelThreshold: 3,
                showPercentage: true,
                showAbsoluteValue: false,
                sortByValue: true
            }
        }],
    ]);
};

// Legacy support - keeping the old interface for backward compatibility
export const pieTypesOptions = new Map<string, Function>([
    [PieChartType.JURISDICTION_MARKET_CAPS, pieChartTransform.jurisdictionMarketCapsToPieDO]
]) 